import mitt, {Emitter} from "mitt";
import {onUnmounted} from "vue";

// type Handler<T = unknown> = (event: T) => void;
type EventHandlers<T extends Record<string, unknown>> = {
    [K in keyof T]: (event: T[K]) => void;
};

export function useMittEvents<T extends Record<string, unknown>>(
    mitt: Emitter<T>,
    handlers: EventHandlers<T>
) {
    for (const key of Object.keys(handlers)) {
        mitt.on(key, handlers[key]);
    }

    function cleanup() {
        for (const key of Object.keys(handlers)) {
            mitt.off(key, handlers[key]);
        }
    }
    onUnmounted(cleanup);
    return cleanup;
}

type EventBus = {
    onRequestsUpdated: void;
    onTasksUpdated: void,
    onExpiringIdUpdated: void,
    onPaymentRecorded: void,
};

const eventBus = mitt<EventBus>();
export function useEventBus() {
    return eventBus;
}
